/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import { hideIntercomWidgetWhenLoaded } from 'embercom/lib/intercom-widget-helper';
import type Nexus from 'embercom/services/nexus';
import type CopilotApi from 'embercom/services/copilot-api';
import type SuiteMigrationService from 'embercom/services/suite-migration-service';

export default class AppsAppCopilotRoute extends Route {
  @service declare appService: AppService;
  @service declare session: Session;
  @service declare nexus: Nexus;
  @service declare copilotApi: CopilotApi;
  @service declare suiteMigrationService: SuiteMigrationService;

  async beforeModel() {
    hideIntercomWidgetWhenLoaded();

    this.session.switchWorkspace(this.appService.app.id);
    this.session.workspace.standaloneCopilotFrameEnabled = true; // for ai-assist command-k actions
    this.copilotApi.setup(); // For conversation excerpt content source
    this.suiteMigrationService.forceSuiteVersion = false; // allow customers to use Copilot during migration
    await this.session.getTeammate(this.appService.app.id);

    this.nexus.start();
  }
}
